import React from 'react';
import { segmentClassForNameOption } from '../../lib/milestoneNameOptions';

export default function MilestoneNameChoiceField({
  options = [],
  value = '',
  onChange,
  disabled = false,
  label = 'Choisir une valeur',
  required = true,
}) {
  if (!options?.length) return null;

  return (
    <div className="space-y-2">
      <p className="text-xs font-semibold text-muted-foreground uppercase tracking-wide">
        {label}
        {required ? <span className="text-destructive"> *</span> : null}
      </p>
      <div
        className={`grid gap-2 ${options.length === 2 ? 'grid-cols-2' : 'grid-cols-1 sm:grid-cols-2'}`}
        role="radiogroup"
        aria-label={label}
      >
        {options.map((opt) => {
          const selected = value === opt.label;
          return (
            <button
              key={opt.id || opt.code}
              type="button"
              role="radio"
              aria-checked={selected}
              disabled={disabled}
              onClick={() => onChange?.(opt.label)}
              className={`min-h-[52px] rounded-xl text-sm font-semibold border cursor-pointer transition-colors disabled:opacity-50 ${
                selected ? segmentClassForNameOption(opt) : 'border-border text-muted-foreground hover:bg-muted/50'
              }`}
            >
              {opt.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
